module.exports = __webpack_public_path__ + "img/9788970138039.943f0f94.jpg";